import React from "react";
import "./context_components.css";
import { useSelector } from "react-redux";


export function DotLoader(props) {
  const { loading } = useSelector(state => state.feedbackStore);
  const { color } = useSelector(state => state.themeStore)

  return (
    <div>
      {loading &&
        <div className="dot-loading">
          <span
            style={{
              backgroundColor: color
            }}
          ></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
        </div>}
    </div>
  );
}

export default DotLoader;